module.exports = __webpack_public_path__ + "static/media/celsius.9bf24d20.svg";